const getCustomerPhone = (customerProfile, address) => {
  return customerProfile?.phone?.prefix || customerProfile?.phone?.number ? customerProfile.phone : address?.phone
}

export const getCustomerProfile = ({ customerProfile, email, address }) => {
  return {
    ...customerProfile,
    email,
    phone: getCustomerPhone(customerProfile, address),
  }
}
